import { useMemo } from 'react';
import { LinkId } from '../../../common/AnalyticsContext/LinkId';
import { useSearchFilters } from '../../../common/components/SearchHeader/filters/useSearchFilters';
import { TimePreset } from '../../../common/schema/hannibal/types.generated';
import { DropDownEnumFilter } from '../EnumFilter/DropDownEnumFilter/DropDownEnumFilter';
import { Option } from '../EnumFilter/RadioGroup/RadioGroup';
import { DropDownFilterPill } from '../FilterPill/DropDownFilterPill';
import { useOverlay } from '../overlay/OverlayContext';

const TITLE = 'Time';

export const TimeFilter = () => {
  const [filters, setFilters] = useSearchFilters();
  const { clear } = useOverlay();
  const time = filters.onlineAppointments?.time;

  const handleChange = (nextTime: TimePreset | undefined): void => {
    setFilters({
      ...filters,
      onlineAppointments: { ...filters.onlineAppointments, time: nextTime },
    });

    clear();
  };

  const caption = useMemo(() => {
    if (time === TimePreset.Am) return 'AM';
    if (time === TimePreset.Pm) return 'PM';
    if (time === TimePreset.AfterHours) return 'Afterhours';
    return TITLE;
  }, [time]);

  const handleClear = () =>
    setFilters({
      ...filters,
      onlineAppointments: { ...filters.onlineAppointments, time: undefined },
    });

  return (
    <DropDownFilterPill
      hasValue={filters.onlineAppointments?.time !== undefined}
      onClear={handleClear}
      caption={caption}
      trackingId={LinkId.FILTER_BY_TIME_BUTTON}
      content={
        <DropDownEnumFilter<TimePreset | undefined>
          value={filters.onlineAppointments?.time}
          filterTitle="Time of day"
          options={OPTIONS}
          onChange={handleChange}
        />
      }
    />
  );
};

const OPTIONS: Option<TimePreset | undefined>[] = [
  { label: 'Any', value: undefined },
  { label: 'AM', value: TimePreset.Am, description: '12am - 12pm' },
  { label: 'PM', value: TimePreset.Pm, description: '12pm - 6pm' },
  { label: 'Afterhours', value: TimePreset.AfterHours, description: '6pm - 12am' },
];
